const BaseCategoryPage = require('base/category-page');
const Server = require('helper/server');
const { walkNoTextTree } = require('helper/util');
// const { districtCode } = require('helper/config');
const { searchAgencyAndSupplier, treeData } = require('helper/search');

const agentListTpl = Handlebars.templates['templates/category-agent-list-tpl'];
const supplierListTpl = Handlebars.templates['templates/category-supplier-list-tpl'];

class OrgCategory extends BaseCategoryPage {
  search () {
    searchAgencyAndSupplier.apply(this);
    // this.$content.find('.block__content').spin(); // 搜索前先旋转
    // const { code, text } = this.selectedTreeNode;
    // // 两种情况:代理机构列表、供应商列表
    // if (this.rootType.includes('代理机构')) {
    //   const requestData = {
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize,
    //     regDist: code
    //   };
    //   if (this.query.get('keyword')) {
    //     requestData.fullName = this.query.get('keyword');
    //   }
    //   this.renderAgentList(requestData);
    // } else {
    //   const requestData = {
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize,
    //     district: districtCode
    //   };
    //   switch (text) {
    //     case '公示中':
    //       requestData.auditStatus = 'PUBLIC_COMMENT';
    //       break;
    //     case '待入库':
    //       requestData.auditStatus = 'PUBLIC_COMMENT_END';
    //       break;
    //     default:
    //       requestData.status = 'OFFICIAL';
    //       break;
    //   }

    //   if (this.query.get('keyword')) {
    //     requestData.name = this.query.get('keyword');
    //   }
    //   this.renderSupplierList(requestData);
    // }
  }

  renderAgentList (payload) {
    const { articleModelFile } = super.treeData();
    Server.getAgentList({ data: payload })
      .done(({ total = 0, data = [] }) => {
        if (data && data instanceof Array) {
          data.forEach((item, index) => {
            item.index = index + 1;
          });
        }
        this.$content.find('.block__content').html(agentListTpl({
          _DATA_: data,
          _pageSize_: this.pageSize || '15',
          _PATH_: articleModelFile
        }));
        this.$el.find('.block__content .total').text(total || 0);
        this.initPagination(total);
      });
  }

  renderSupplierList (payload) {
    const { articleModelFile } = super.treeData();
    Server.getSupplierList({ data: {...payload,district: 140000} })
      .done(({ total = 0, data = [] }) => {
        if (data && data instanceof Array) {
          data.forEach((item, index) => {
            item.index = index + 1;
          });
        }
        this.$content.find('.block__content').html(supplierListTpl({
          _DATA_: data,
          _pageSize_: this.pageSize || '15',
          _PATH_: articleModelFile
        }));
        this.$el.find('.block__content .total').text(total || 0);
        this.initPagination(total);
      });
  }

  selectTreeNode (e, { instance }) {
    this.renderBreadcrumb(instance);
    this.$content.find('.block__content').spin();
    this.search();
  }

  async treeData () {
    let data = await treeData.apply(this);
    if (data) { return data; }
    return super.treeData();
  }
}

module.exports = OrgCategory;
